export default "__VITE_ASSET__C3ZCyc3I__"